import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthModule as Auth0Module } from '@auth0/auth0-angular';

import { AuthRoutingModule } from './auth-routing.module';
import { PATHS_DICT, ROUTES_PREFIX } from './auth.routes';
import { CallbackPageComponent } from './pages/callback-page.component';
import { ErrorPageComponent } from './pages/error-page.component';
import { LoginPageComponent } from './pages/login-page.component';
import { LogOutPageComponent } from './pages/logout-page.component';
import { SignUpPageComponent } from './pages/signup-page.component';

import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    SignUpPageComponent,
    LoginPageComponent,
    CallbackPageComponent,
    LogOutPageComponent,
    ErrorPageComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    Auth0Module.forRoot({
      clientId: environment.auth0_clientId,
      domain: environment.auth0_domain,
      errorPath: PATHS_DICT.ERROR,
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        redirect_uri: new URL(`${ROUTES_PREFIX}/${PATHS_DICT.CALLBACK}`, window.location.origin).href
      }
    })
  ]
})
export class AuthModule {}
